import { render, staticRenderFns } from "./PublishTrademarkDemand.vue?vue&type=template&id=762bbc0d&scoped=true"
import script from "./PublishTrademarkDemand.vue?vue&type=script&lang=js"
export * from "./PublishTrademarkDemand.vue?vue&type=script&lang=js"
import style0 from "./PublishTrademarkDemand.vue?vue&type=style&index=0&id=762bbc0d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762bbc0d",
  null
  
)

export default component.exports